import nestGet from '@tmap/mmm-core/nestGet';
import makeView from '@tmap/mmm-core/redux/views/makeView';

import { getClient } from '../lib/apiClient';
import {
  FETCH_QUESTION_MODULE,
  RECEIVE_QUESTION_MODULE,
  UPDATE_QUESTION_FIELDS,
} from '../reducers/questions';
import getLocalStorage from '../lib/getLocalStorage';

export function getQuestionModule(moduleName) {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_QUESTION_MODULE, moduleName });
    const result = await getClient(process.env.NEXT_PUBLIC_API_DOMAIN, getState)
      .get(`/api/v1/questions/module/${moduleName}`);
    dispatch({
      type: RECEIVE_QUESTION_MODULE,
      moduleName,
      data: result.data,
    });
  };
}

export const getQuestionFields = makeView(
  async (moduleName) => {
    const result = await getClient(process.env.NEXT_PUBLIC_API_DOMAIN)
      .get(`/api/v1/questions/module/${moduleName}/fields`);
    return ({
      docs: result.data,
    });
  },
);

export function saveQuestionFields({ moduleName, answers }) {
  return async (dispatch, getState) => {
    const userProfile = nestGet(getState(), ['users', 'current']);

    if (Object.keys(userProfile).length > 0) {
      await getClient(process.env.NEXT_PUBLIC_API_DOMAIN, getState)
        .post(`/api/v1/questions/module/${moduleName}`, {
          ...answers,
        });
    } else {
      const localStorage = getLocalStorage();
      if (localStorage) {
        const currentValue = JSON.parse(localStorage.getItem('questionModules') || '{}');
        localStorage.setItem('questionModules', JSON.stringify({
          ...currentValue,
          [moduleName]: {
            ...(currentValue[moduleName] || {}),
            ...answers,
          },
        }));
      }
    }
    dispatch({
      type: UPDATE_QUESTION_FIELDS,
      answers,
    });
  };
}
